import React, { useEffect, useContext } from 'react';
import axiosConfig from './utils/axiosConfig';
import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import Cookies from 'js-cookie';

import { useImmerReducer } from 'use-immer';
import { debugContextDevtool } from 'react-context-devtool';
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import {ThemeProvider, createMuiTheme} from '@material-ui/core';
import theme from './theme';

/* Components */
import ProtectedRoute from './containers/Shared/ProtectedRoute/ProtectedRoute';
import UnprotectedRoute from './containers/Shared/UnprotectedRoute/UnprotectedRoute';
import NotFoundPage from './components/Shared/StaticPages/NotFoundPage';

/* Main Layouts */
import ResponsiveLayout from './containers/Layouts/ResponsiveLayout';

/* Master */
import MasterLogin from './containers/Master/Login/Login';
import ForgotPassword from './containers/Shared/ForgotPassword/ForgotPassword';
import ResetPassword from './containers/Shared/ResetPassword/ResetPassword';
import MasterDashboard from './containers/Master/Dashboard/Dashboard';
import Roles from './containers/Master/Roles/Roles';
import Users from './containers/Master/Users/Users';
import Students from './containers/Master/Students/Students';
import ManageSchools from './containers/Master/ManageSchools/ManageSchools';
import MasterSettings from './containers/Master/Settings/Settings';
import Logout from './containers/Shared/Logout/Logout';

/* Faculty */
import Calendar from './containers/Shared/Calendar/Calendar';
import FacultyDashboard from './containers/Faculty/Dashboard/Dashboard';
import FacultyNewsfeed from './containers/Faculty/Newsfeed/Newsfeed';
import FacultyClasswork from './containers/Faculty/Classwork/Classwork';
import ViewClasswork from './containers/Faculty/Classwork/ViewClasswork/ViewClasswork';
import ViewClassworkSubmissions from './containers/Faculty/Classwork/ViewClassworkSubmissions/ViewClassworkSubmissions';
import ClassworkSubmissionComments from './containers/Faculty/Classwork/ViewClassworkSubmissions/Comments/Comments.js';

/** Subject Coordinator */
import SubjectCoordinatorDashboard from 'containers/SubjectCoordinator/Dashboard.js';

import FacultyParticipants from './containers/Faculty/Participants/Participants';
import FacultyGrading from './containers/Faculty/Grading/Grading';

/* Shared */
import HelpPage from './containers/Shared/HelpPage/HelpPage';
import MyAccount from './containers/Shared/MyAccount/MyAccount';
import Ebooks from './containers/Shared/Ebooks/Ebooks';
import EbookItem from './containers/Shared/Ebooks/EbookItem/EbookItem';

import Classroom from './containers/Faculty/Classroom/Classroom';

/* Context */
import { GlobalProvider, StateContext, DispatchContext } from './context/Provider';
import Announcements from 'containers/Announcements/Announcements';
import ViewMessage from 'containers/Messages/ViewMessage'
import AllMessages from 'containers/Messages/AllMessages'

/** Examination */
import ExaminationDashboard from 'containers/Examination/ExaminationDashboard'
import ExaminationEditor from 'containers/Examination/ExaminationEditor'
import StudentDashboard from 'containers/Examination/StudentDashboard'
import StudentExamForm from 'containers/Examination/StudentExamForm'
import StudentAttempts from 'containers/Examination/StudentAttempts'
import StudentSubmissions from 'containers/Examination/FacultyDashboard/StudentSubmissions'
import StudentSubmission from 'containers/Examination/FacultyDashboard/StudentSubmission'
import StudentViewAttempt from 'containers/Examination/StudentViewAttempt'

// export const history = createBrowserHistory();

const Main = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { authDispatch } = appDispatch;

    const getSubdomain = () => {
        let host = window.location.host;
        let protocol = window.location.protocol;
        let parts = host.split(".");
        let subdomain = authState.user.subdomain || 'ap';

        // If we get more than 3 parts, then we have a subdomain
        // INFO: This could be 4, if you have a co.uk TLD or something like that.
        if (parts.length < 3 && authState.user.role_id !== 1 && authState.loggedIn) {
            // console.log(authState);
            // subdomain = parts[0];
            // window.location = protocol + "//" + parts.join(".") + "/" + subdomain;
            // window.location = protocol + "//" + subdomain + '.' + parts.join(".") + "/";
        }
    }

    useEffect(() => {

        // console.log("isLoggedIn", authState.loggedIn)

        if (authState.loggedIn) {
            axiosConfig.get(`/auth/authUser`)
            .then(res => {
                const { data } = res;
                authDispatch({ type: "setUser", data});

                console.log(data)

                if (data.is_new === 1) {
                    const firstPath = window.location.pathname.split('/')[1];
                    if (firstPath !== 'reset-password') {
                        window.location = `/reset-password/${data.resetToken}`;
                    }
                }
            })
            .catch(err => {
                authDispatch({type: "logout"});
                console.log("Redirecting to login", err);
                window.location = '/login';
            });

            getSubdomain();
        }

    }, []);

    let routes = (
        <Switch>
            <ProtectedRoute exact path="/" component={MasterDashboard} />
            <ProtectedRoute exact path="/my-account" component={MyAccount} />
            <UnprotectedRoute exact path="/login" component={MasterLogin} />
            <UnprotectedRoute exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password/:token" component={ResetPassword} />
            <Route exact path="/logout" component={Logout} />

            <ProtectedRoute exact path="/dashboard" component={MasterDashboard} />

            <ProtectedRoute exact path="/roles" component={Roles} />
            <ProtectedRoute exact path="/system-users" component={Users} />
            <ProtectedRoute exact path="/manage-schools" component={ManageSchools} />
            <ProtectedRoute exact path="/master-settings" component={MasterSettings} />

            <ProtectedRoute exact path='/message/all' component={AllMessages} />
            <ProtectedRoute exact path='/message/:messageid' component={ViewMessage} />

            <Redirect to="/dashboard" />
            {/* <Route exact component={NotFoundPage}></Route> */}
        </Switch>
    );

    // School Admin
    if (authState.user.role_id === 2) {
        routes = (
            <Switch>
                <ProtectedRoute exact path="/" component={FacultyDashboard} />
                <ProtectedRoute exact path="/my-account" component={MyAccount} />
                <UnprotectedRoute exact path="/login" component={MasterLogin} />
                <UnprotectedRoute exact path="/forgot-password" component={ForgotPassword} />
                <Route exact path="/reset-password/:token" component={ResetPassword} />
                <Route exact path="/logout" component={Logout}></Route>

                <ProtectedRoute exact path="/dashboard" component={MasterDashboard} />
                <ProtectedRoute exact path="/system-users" component={Users} />
                <ProtectedRoute exact path="/students" component={Students} />
            </Switch>
        );
    }

    // Subject Coordinator / Faculty / Student Routes
    if (authState.user.role_id === 3 || authState.user.role_id === 4 || authState.user.role_id === 5) {
        routes = (
            <Switch>
                <ProtectedRoute exact path="/" component={FacultyDashboard} />
                <ProtectedRoute exact path="/my-account" component={MyAccount} />
                <UnprotectedRoute exact path="/login" component={MasterLogin} />
                <UnprotectedRoute exact path="/forgot-password" component={ForgotPassword} />
                <Route exact path="/reset-password/:token" component={ResetPassword} />
                <Route exact path="/logout" component={Logout} />

                {authState.user.role_id === 3 && (
                    <ProtectedRoute exact path="/dashboard" component={FacultyDashboard} />
                )}

                {(authState.user.role_id === 4 || authState.user.role_id === 5) && (
                    <ProtectedRoute exact path="/dashboard" component={FacultyDashboard} />
                )}

                <ProtectedRoute exact path="/calendar" component={Calendar} />

                <ProtectedRoute exact path="/e-books" component={Ebooks} />
                <ProtectedRoute path="/e-books/:book_id" component={EbookItem} />

                <ProtectedRoute path="/:classcode/newsfeed" component={FacultyNewsfeed} />
                <ProtectedRoute path="/:classcode/classwork" exact component={FacultyClasswork} />
                <ProtectedRoute path="/:classcode/classwork/:classwork_id" exact component={ViewClasswork} />
                <ProtectedRoute path="/:classcode/classworkSubmissions/:classwork_id" exact component={ViewClassworkSubmissions} />
                <ProtectedRoute path="/:classcode/classworkSubmissionComments/:classwork_id/:student_id" exact component={ClassworkSubmissionComments} />

                <ProtectedRoute path="/:classcode/participants" component={FacultyParticipants} />
                <ProtectedRoute path="/:classcode/grading" component={FacultyGrading} />

                <ProtectedRoute path="/:classcode/meet/:username" component={Classroom}/>

                <ProtectedRoute path="/archived-classrooms" archived  component={FacultyDashboard} />

                <ProtectedRoute path="/announcements"  component={Announcements} />
                <ProtectedRoute path='/message/all' component={AllMessages} />
                <ProtectedRoute path='/message/:messageid' component={ViewMessage} />

                {authState.user.permissions?.examinations === 'faculty' && <>
                    <ProtectedRoute exact path='/examinations/:exam/edit' component={ExaminationEditor} />
                    <ProtectedRoute exact path='/examinations' component={ExaminationDashboard}/>
                    <ProtectedRoute exact path='/examinations/:exam/submissions' component={StudentSubmissions}/>
                    <ProtectedRoute exact path='/examinations/:exam/submissions/:student' component={StudentSubmission}/>
                </>}

                {authState.user.permissions?.examinations === 'student' && <>
                    <ProtectedRoute exact path='/examinations' component={StudentDashboard}/>
                    <ProtectedRoute exact path='/examinations/:exam/form' component={StudentExamForm}/>
                    <ProtectedRoute exact path='/examinations/:exam/attempts' component={StudentAttempts}/>
                    <ProtectedRoute exact path='/examinations/:exam/attempts/:attempt' component={StudentViewAttempt}/>
                </>}

                {/* <Redirect to="/dashboard" /> */}
            </Switch>
        );
    }

    if (window.location.host.split(".")[0] === "help") {
        routes = (<HelpPage />);
    }

    return routes;
}

ReactDOM.render(
    <BrowserRouter>
        <ThemeProvider theme={theme}>
            <GlobalProvider>
                <Main />
            </GlobalProvider>
        </ThemeProvider>
    </BrowserRouter>,
    document.getElementById('root')
);

// let options = {
//     debugReducer: true,
//     debugContext: true
// }

// debugContextDevtool(document.getElementById('root'), options);

// http://localhost/clients/epi-ap/backend/public/api
// http://18.216.94.205:8080/api
// https://api.academeportal.com/api

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();